<template>
  <div class="row gutter-md ext-form-config">
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
      <h4 class="separator">
        {{$t('ui.external_form.frontend_actions')}}
      </h4>
      <email-list
        v-model="config.actions.send_team_confirmation_mail.emails"
        :label="$t('ui.external_form.send_notification_to')"
      />


      <div class="checkbox-wrapper">
        <div>
          <div class="status-switch">
            <div class="row">
              <div>
                <input type="radio" id="success_message" value="enabled" v-model="config.actions.success_message.status">
                <label class="form-label" for="success_message">{{$t('ui.external_form.success_message')}}</label>
              </div>
              <div>
                <input type="radio" id="redirect_to" value="enabled" v-model="config.actions.redirect_to.status">
                <label class="form-label" for="redirect_to">{{$t('ui.external_form.redirection_url')}}</label>
              </div>
            </div>
            <div :class="{'hidden': config.actions.success_message.status === 'disabled'}">
              <field v-model="config.actions.success_message.content" label="empty" placeholder="Thank you!" type="textarea"/>
            </div>
            <div :class="{'hidden': config.actions.redirect_to.status === 'disabled'}">
              <field v-model="config.actions.redirect_to.url" label="empty" placeholder="https://fanomena.io" type="text"/>
            </div>
          </div>
        </div>
      </div>

      <h4 class="separator">
        {{ $t('ui.external_form.follow_up') }}
      </h4>
      <div>
        <div class="vertical-center">
          <input
            type="checkbox"
            id="bk_status"
            class="is-inline-block vertical-center"
            true-value="enabled"
            false-value="disabled"
            name="business_kit_boarding_status"
            v-model="config.actions.board_businesskit.status"
          >
          <label
            class="checkbox-text"
            for="bk_status"
          >
            {{ $t('ui.external_form.bk_boarding')  }}
          </label>
        </div>
        <field
          class="select-field"
          :readonly="config.actions.board_businesskit.status === 'disabled' ? true : false"
          v-model="config.actions.board_businesskit.eventbaxx_event_foreign_id"
          :collection="businessKitCollection"
          type="select"
          name="business_kit_boarding"
          label="empty"
          :params="{no_i18n: true}"
        />
      </div>

      <div class="vertical-center">
        <input
          type="checkbox"
          class="is-inline-block"
          :disabled="config.actions.board_businesskit.status === 'disabled' ? true : false"
          v-model="config.actions.board_businesskit.send_directly"
          :true-value="false"
          :false-value="true"
          id="bk_send_directly"
        >
        <label
          class="checkbox-text"
          for="bk_send_directly"
          :class="{'text-disabled': config.actions.board_businesskit.status === 'disabled' ? true : false}"
        >
          {{$t('ui.external_form.send_directly')}}
        </label>
      </div>

      <div class="is-block separator">
        <div class="vertical-center">
          <input
            type="checkbox"
            true-value="enabled"
            false-value="disabled"
            name="send_team_confirmation_mail_status"
            v-model="config.actions.send_lead_confirmation_mail.status"
            id="lead_mail_status"
          >
          <label
            class="checkbox-text"
            for="lead_mail_status"
          >
            {{$t('ui.external_form.email_notification')}}
          </label>
        </div>
      </div>

      <div class="max-width">
        <field
          v-model="config.actions.send_lead_confirmation_mail.email_template_foreign_id"
          :collection="emailTemplateCollection"
          :disabled="config.actions.send_lead_confirmation_mail.status === 'disabled' ? true : false"
          type="select"
          name="send_lead_confirmation_mail_template"
          :label="$t('ui.external_form.email_template')"
          :params="{no_i18n: true}"
        />
        <field
          v-model="config.actions.send_lead_confirmation_mail.subject"
          :disabled="NoPresentEmailTemplateOrDisabled(config)"
          name="send_lead_confirmation_mail_subject"
          :label="$t('ui.external_form.mail_subject')"
        />
        <field
          v-model="config.actions.send_lead_confirmation_mail.url"
          :disabled="NoPresentEmailTemplateOrDisabled(config)"
          name="send_lead_confirmation_mail_url"
          :label="$t('ui.external_form.mail_url')"
        />
        <field
          v-model="config.actions.send_lead_confirmation_mail.cta_text"
          :disabled="NoPresentEmailTemplateOrDisabled(config)"
          name="send_lead_confirmation_mail_cta"
          :label="$t('ui.external_form.mail_cta')"
        />
      </div>
    </div>

    <div class="col-12">
      <h5>
        Integrations
      </h5>
      <go-to-webinar
        :active="config.actions.board_citrix.status === 'enabled' ? true : false"
        @activeInput="switchCitrixStatus()"
        v-model="config.actions.board_citrix.citrix_webinar_keys"
      />
    </div>
  </div>
</template>
<script>
import Field from '@/components/helpers/DataInput/Field'
import BusinessKitApi from '@/api/BusinessKit'
import EmailTemplateApi from '@/api/EmailTemplate'
import EmailList from '@/components/helpers/DataInput/EmailList'
import TagList from '@/components/helpers/DataInput/TagList'
import GoToWebinar from '@/components/helpers/DataInput/integrations/GoToWebinar'

export default {
  components: {
    Field,
    EmailList,
    TagList,
    GoToWebinar
  },
  props: {
    value: {
      type: Object,
      default: () => { return {} }
    }
  },
  data(){
    return {
      // collections
      businessKitCollection: [],
      emailTemplateCollection: [],
      defaultConfig: {
        actions: {
          board_businesskit: {
            status: 'disabled',
            send_directly: false,
            eventbaxx_event_foreign_id: null
          },
          board_citrix: {
            citrix_webinar_keys: [],
            status: 'disabled'
          },
          redirect_to: {
            status: 'disabled',
            url: ''
          },
          send_lead_confirmation_mail: {
            email_template_foreign_id: null,
            cta_text: '',
            status: 'disabled',
            subject: '',
            url: ''
          },
          send_team_confirmation_mail: {
            emails: [],
            status: 'disabled',
          },
          success_message: {
            content: 'Thank you!',
            status: 'enabled'
          },
          board_mailchimp: {
            mailchimp_merge_field_configuration: {},
            status: 'disabled'
          }
        }
      }
    }
  },
  computed: {
    config() {
      // Use value prop but also Validate that it contains all necessary attributes
      let configuration = this.defaultConfig
      if (!this.value.actions) { return configuration }
      Object.keys(this.value.actions).forEach((key) => {
        let hash = this.value.actions[key]
        // If key is not present in defaultConfig we add it
        if (!configuration['actions'][key]) {
          configurations['actions'][key] = hash
        }
        Object.keys(hash).forEach((keyInner) => {
          let valueInner = hash[keyInner]
          configuration['actions'][key][keyInner] = valueInner
        })
      })
      return configuration
    }
  },
  mounted(){
    this.retrieve()
  },
  methods: {
    switchCitrixStatus() {
      // Flip from 'disabled' to 'enabled' or other wa
      let status = 'disabled'
      if (this.config.actions.board_citrix.status === 'disabled') {
        status = 'enabled'
      }
      this.config.actions.board_citrix.status = status
    },
    retrieve(){
      let bk_api = new BusinessKitApi
      bk_api.all_for_association().then(items=>{
        this.businessKitCollection = items
      })
      let et_api = new EmailTemplateApi
      et_api.all_for_association().then(items=>{
        this.emailTemplateCollection = items
      })
    },
    handleSendTeamConfirmationMailStatus() {
      let options = this.config.actions.send_team_confirmation_mail
      let enabled = "disabled"
      if (options.emails.length > 0) {
        enabled = "enabled"
      }
      this.config.actions.send_team_confirmation_mail.status = enabled
    },
    handleRedirectToAndSuccessMessage(origin) {
      // Flip the two actions
      if (origin === 'success_message') {
        this.config.actions.redirect_to.status = 'disabled'
      } else {
        this.config.actions.success_message.status = 'disabled'
      }
    },
    NoPresentEmailTemplateOrDisabled(config){
      return (config.actions.send_lead_confirmation_mail.status === 'disabled' || config.actions.send_lead_confirmation_mail.email_template_foreign_id === null )
    }
  },
  watch: {
    'config.actions.send_lead_confirmation_mail.status'(val) {
      if (val === 'disabled') {
        this.config.actions.send_lead_confirmation_mail.url = ''
        this.config.actions.send_lead_confirmation_mail.cta_text = ''
        this.config.actions.send_lead_confirmation_mail.subject = ''
        this.config.actions.send_lead_confirmation_mail.email_template_foreign_id = null
      }
    },
    'config.actions.board_businesskit.status'(val) {
      if (val === 'disabled') {
        this.config.actions.board_businesskit.eventbaxx_event_foreign_id = null
        this.config.actions.board_businesskit.send_directly = false
      }
    },
    'config.actions.success_message.status'(val) {
      // Only one can be turned on at any time
      if (val === 'enabled') {
        this.handleRedirectToAndSuccessMessage('success_message')
      }
    },
    'config.actions.redirect_to.status'(val) {
      // Only one can be turned on at any time
      if (val === 'enabled') {
        this.handleRedirectToAndSuccessMessage('redirect_to')
      }
    },
    'config.actions.send_team_confirmation_mail.emails'() {
      // Automatically turn feature on/off depending on if emails are present in input
      this.handleSendTeamConfirmationMailStatus()
    },
    config: {
      deep: true,
      handler(val) {
        this.$emit('input', val)
      }
    },
  }
}
</script>
<style lang="scss">
.ext-form-config {
  select {
    margin: 2px 0 8px !important;
  }
}

#redirect_to {
  margin-left: 20px;
}
.checkbox-text {
  margin-left: 5px;
}

.text-disabled {
  opacity: 0.7;
}

.vertical-center {
  display: flex;
  align-content: center;
}

.separator {
  margin: 0;
  padding-top: 42px;
  padding-bottom: 12px;
}

.checkbox-wrapper {
  margin-top: 40px;
}

.hidden{
  display: none!important;
}

.optional{
    display: none!important;
  }

.is-inline {
  display: inline;
}

.is-inline-block {
  display: inline-block;
}

.form-label{
  font-size: 1em;
  font-weight: 500;
  line-height: 24px;
  color: #212736;
  padding-bottom: 20px;
  margin-bottom: 20px;
  text-align: left;
}
.float-left {
  float: 'left'
}
.email-list-input{
  width: 100%;
}
.thank-you-message{
  min-height: 220px;
  min-width: 460px;
  border: 2px solid #C4CDD5;
  border-radius: 3px;
  font-size: 1em;
  font-weight: 400;
  color: #212736;
  margin-top: 20px;
  margin-bottom: 20px;
  height: 40px;
  padding-left: 15px;
  -webkit-transition: all .15s ease-out;
  transition: all .15s ease-out;
}

.margin-top-bottom {
  margin-top: 20px!important;
  margin-bottom: 20px;
}

.padding-top {
  padding-top: 20px
}

.redirect{
  border: 2px solid #C4CDD5;
  border-radius: 3px;
  font-size: 1em;
  min-width: 460px;
  font-weight: 400;
  color: #212736;
  margin-top: 20px;
  height: 40px;
  padding-left: 15px;
  -webkit-transition: all .15s ease-out;
  transition: all .15s ease-out;
}

.frontend-actions {
  font-size: 17px!important;

}

.is-block {
  display: block;
}

.radio{
  vertical-align: middle;
}
.external-form--config{
  .email-list--item, .email-list-input{
    height: 32px;
    padding: 5px 6px;

  }

  .success-message {
    height: 220px;
    width: 912px;
    background: white;
  }

  .max-width {
    max-width: 460px;
  }

  .send-directly{
    margin-top: 10px;
    label{
      color: #9e9e9e;
      margin-left: 3px;
      vertical-align: middle;
    }
    input{
      vertical-align: middle;
    }
  }

  .status-switch{
    flex-basis: 30px;
    flex-grow: 0;
    align-self: center;
  }
  .config-field{
    .field{
      margin-top: 0;
    }
  }

  .is-disabled .config-field{
    opacity: 0.5;
  }
}
@media(max-width: 575px) {
  .status-switch .textarea-input {
    min-width: 100%;
  }
  .ext-form-config {
    .row {
    flex-direction: column-reverse;
    }
    .wrapper {
      padding: 10px !important;
      margin-bottom: 20px;
    }
    .switch {
      display: block !important;
      margin-bottom: 20px;
    }
  }
}
@media(max-width: 392px) {
  #redirect_to {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ExternalFormConfiguration.vue?35f11d42